<template>
    <div class="space-y-4" :class="{'opacity-40 cursor-disabled pointer-events-none':sending}">

        <div class="uppercase font-semibold tracking-2xl opacity-30 text-sm">Contact</div>
        <div class="text-2xl !mt-0">{{ church?.name || church?.title || 'Church & Family Life' }}</div>
        <div class="text-xs text-gray-500 !mt-1"><span class="text-red-600">*</span> Required fields</div>

        <div v-if="!store.user?.member?.firstName">
            <input type="text" v-model="contactForm.name" placeholder="Name *" aria-required="true" />
        </div>
        <div v-if="!store.user?.member?.email">
            <input type="email" validate="email" v-model="contactForm.email" placeholder="Email *" aria-required="true" />
        </div>

        <div class="space-x-4 flex">
            <input type="text" v-model="contactForm.phone" placeholder="Phone (optional)" />
            <input type="text" v-model="contactForm.zip" placeholder="Zip Code (optional)" />
        </div>

        <!-- HAP-4231 honeypot: hidden from humans (off-screen, not tabbable, no
             autofill); a form-spam bot that fills every input trips it and the
             server drops the submit with no email. Real users never see it. -->
        <div class="hp-field" aria-hidden="true">
            <label>Website<input type="text" v-model="contactForm.website" tabindex="-1" autocomplete="off" /></label>
        </div>

        <div><input type="text" v-model="contactForm.subject" placeholder="Subject *" aria-required="true" /></div>

        <!-- <QuillEditor
            v-model:content="contactForm.body" contentType="html"
            theme="bubble"
            class="article dark:text-gray-400 relative border dark:border-gray-600 rounded-lg w-full !h-48 article-sm"
            placeholder="Write a description..."
        /> -->

        <!-- <Tiny
            :init="{skin: darkMode.enabled ? 'oxide-dark' : null, content_css: darkMode.enabled ? 'dark' : null}"
            plugins="code link fullscreen paste"
            :toolbar="null"
            api-key='iri3ane1rxbx5nlznkt8rpn2023fb3m4uzbdjsiyjzcjtr8e'
            output-format="html"
            v-model="contactForm.body"
        /> -->

        <textarea
            v-model="contactForm.body"
            rows="10"
            placeholder="Message *"
            aria-required="true"
        />

        <button class="rounded px-3 py-2 bg-ncfic-blue-500 dark:bg-ncfic-blue-800 dark:text-white/60 text-white mt-4" @click="sendMessage">
            Send Message
        </button>

		<div v-if="!church" class="w-full text-center text-grey-800 text-xs mt-8">
			Or call us at <a href="tel:919-867-1980">(919) 867-1980</a>.
		</div>

    </div>
</template>

<script>
// import { QuillEditor } from '@vueup/vue-quill'
// import Tiny from '@tinymce/tinymce-vue'
import { validateEmail } from './email'
import Swal from './swal' // lazy sweetalert2 (HAP-4635)
import { fireFormSuccess, fireFormError } from './leadConversion.js'

export default {
    props: ['church'],
    // components: { Tiny },
    inject: ['store','axios','darkMode'],
    data() {
        return {
            sending: false,
            contactForm: {
                name: this.store.user?.member?.firstName ? `${this.store.user?.member?.firstName} ${this.store.user?.member?.lastName}` : null,
                phone: null,
                zip: null,
                email: this.store.user?.member?.email ? `${this.store.user.member.email}` : null,
                subject: null,
                body: null,
                website: null // HAP-4231 honeypot — must stay empty for real users
            }
        }
    },
    methods: {
        async sendMessage() {

            this.contactForm.email = this.contactForm.email || this.store.user?.member?.email
            this.contactForm.name = this.contactForm.name || `${this.store.user?.member?.firstName || ''} ${this.store.user?.member?.lastName || ''}`.trim() || null

            if (!this.contactForm.name) return Swal.fire('Empty Name', 'Please provide your name before sending.', 'warning')
            if (!this.contactForm.email) return Swal.fire('Empty Email', 'Please provide an email address before sending.', 'warning')
            if (!this.contactForm.body) return Swal.fire('Empty Message', 'Please write a message before sending.', 'warning')
            if (!this.contactForm.subject) return Swal.fire('Empty Subject', 'Please write a subject before sending.', 'warning')

			if (!validateEmail(this.contactForm.email)) return Swal.fire({
                title: 'Invalid Email',
                text: `${this.contactForm.email} is not a valid email`,
                icon: 'error'
            })


            this.sending = true

            var data = {
                name: this.contactForm.name,
                email: this.contactForm.email,
                phone: this.contactForm.phone,
                zip: this.contactForm.zip,
                subject: this.contactForm.subject,
                body: this.contactForm.body,
                path: window.location.href,
                website: this.contactForm.website, // HAP-4231 honeypot
            }

            if (this.church) data.churchId = this.church.id

            let response = await this.axios.post(`https://api.churchandfamilylife.com/controllers/contact`, data)
            if (response.data?.success) {
                fireFormSuccess({ formId: 'contact_form' })
                this.contactUs = false
                Swal.fire('Message Sent!', 'We\'ve received your message.', 'success')
                this.$emit('sent', true)
            } else {
                fireFormError({ formId: 'contact_form' })
                Swal.fire('Error', 'Something went wrong.', 'error')
            }

            this.sending = false
        }
    }
}
</script>

<style lang="postcss" scoped>
input, textarea {
    @apply border rounded px-3 py-2 w-full dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-600
}
/* HAP-4231 honeypot: pushed off-screen (not display:none — some bots skip that)
   so it's invisible to humans but still present in the DOM for a bot to fill. */
.hp-field {
    position: absolute;
    left: -9999px;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
}
</style>
